import svgShapeStylesCollector from './svgShapeStylesCollector'

export default [svgShapeStylesCollector]
